import { useNavigate } from 'react-router-dom';
import useAxiosInterceptors from "../utils/axiosInterceptor";

const WithAxiosInterceptors = ({ children }) => {
    useAxiosInterceptors(useNavigate);
    return children;
};

export default WithAxiosInterceptors;
